import _objectSpread from "/Users/marcinlukasik/Documents/projects/virtual-tour/admin/node_modules/@babel/runtime/helpers/esm/objectSpread";
function createSnapModifier(gridSize) {
  return function (_ref) {
    var transform = _ref.transform;
    return _objectSpread({}, transform, {
      x: Math.ceil(transform.x / gridSize) * gridSize,
      y: Math.ceil(transform.y / gridSize) * gridSize
    });
  };
}
var restrictToHorizontalAxis = function restrictToHorizontalAxis(_ref2) {
  var transform = _ref2.transform;
  return _objectSpread({}, transform, {
    y: 0
  });
};
function restrictToBoundingRect(transform, rect, boundingRect) {
  var value = _objectSpread({}, transform);
  if (rect.top + transform.y <= boundingRect.top) {
    value.y = boundingRect.top - rect.top;
  } else if (rect.bottom + transform.y >= boundingRect.top + boundingRect.height) {
    value.y = boundingRect.top + boundingRect.height - rect.bottom;
  }
  if (rect.left + transform.x <= boundingRect.left) {
    value.x = boundingRect.left - rect.left;
  } else if (rect.right + transform.x >= boundingRect.left + boundingRect.width) {
    value.x = boundingRect.left + boundingRect.width - rect.right;
  }
  return value;
}
var restrictToParentElement = function restrictToParentElement(_ref3) {
  var transform = _ref3.transform,
    activeNodeRect = _ref3.activeNodeRect,
    containerNodeRect = _ref3.containerNodeRect;
  if (!activeNodeRect || !containerNodeRect) {
    return transform;
  }
  return restrictToBoundingRect(transform, activeNodeRect, containerNodeRect);
};
var restrictToFirstScrollableAncestor = function restrictToFirstScrollableAncestor(_ref4) {
  var transform = _ref4.transform,
    activeNodeRect = _ref4.activeNodeRect,
    scrollableAncestorRects = _ref4.scrollableAncestorRects;
  var firstScrollableAncestorRect = scrollableAncestorRects[0];
  if (!activeNodeRect || !firstScrollableAncestorRect) {
    return transform;
  }
  return restrictToBoundingRect(transform, activeNodeRect, firstScrollableAncestorRect);
};
var restrictToVerticalAxis = function restrictToVerticalAxis(_ref5) {
  var transform = _ref5.transform;
  return _objectSpread({}, transform, {
    x: 0
  });
};
var restrictToWindowEdges = function restrictToWindowEdges(_ref6) {
  var transform = _ref6.transform,
    activeNodeRect = _ref6.activeNodeRect,
    windowRect = _ref6.windowRect;
  if (!activeNodeRect || !windowRect) {
    return transform;
  }
  return restrictToBoundingRect(transform, activeNodeRect, windowRect);
};
export { createSnapModifier, restrictToFirstScrollableAncestor, restrictToHorizontalAxis, restrictToParentElement, restrictToVerticalAxis, restrictToWindowEdges };